import { apiClient, getErrorMessage } from '@/lib/apiClient';
import { ReadOnlyEntityService } from '@/lib/EntityService';
import { UserListItem } from '@/types/identity/Identity';

/**
 * The Users grid's service: /api/identity/user-list serves the list contract <EntityListView>
 * drives (column filters, sorting, paging) plus the grid's multi-row actions. Read-only as far as
 * the shell's single-record CRUD goes — creating and editing a user stays on ABP's
 * /api/identity/users through UserDetailPage.
 */
class UserListService extends ReadOnlyEntityService<UserListItem> {
  constructor() {
    super('/api/identity/user-list', 'User');
  }

  /** Delete the selected users in one call (all-or-nothing on the server). */
  async deleteMany(ids: string[]): Promise<void> {
    try {
      await apiClient.post(`${this.baseUrl}/bulk-delete`, { ids });
    } catch (error) {
      console.error('Error bulk deleting users:', error);
      throw new Error(getErrorMessage(error));
    }
  }

  /**
   * Add roles to every selected user, keeping the roles each already has. The original error is
   * rethrown so the dialog can extract the server's validation messages.
   */
  async addRoles(userIds: string[], roleNames: string[]): Promise<void> {
    await apiClient.post(`${this.baseUrl}/add-roles`, { userIds, roleNames });
  }
}

export const userListService = new UserListService();
